import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import TripApp from './app/TripApp';
import { extractSlugFromPath } from './lib/env';
import { initCapacitorBridge } from './lib/capacitorBridge';
import './styles/global.css';

const slug = extractSlugFromPath();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root nicht gefunden');
}

createRoot(container).render(
  <StrictMode>
    <TripApp slug={slug} />
  </StrictMode>,
);

// Capacitor-Bridge nach dem Render-Start initialisieren (no-op auf Web).
// Push-Permission wird im SPA-UI angefordert, nicht hier — diese Bridge kümmert
// sich nur um Token-Lifecycle + App-URL-Listener.
void initCapacitorBridge();
